"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsAuctionHouseV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "extended",
                type: "bool",
            },
        ],
        name: "AuctionBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "comment",
                type: "string",
            },
        ],
        name: "AuctionBidComment",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionExtended",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minBidIncrementPercentage",
                type: "uint256",
            },
        ],
        name: "AuctionMinBidIncrementPercentageUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reservePrice",
                type: "uint256",
            },
        ],
        name: "AuctionReservePriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AuctionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "timeBuffer",
                type: "uint256",
            },
        ],
        name: "AuctionTimeBufferUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "auction",
        outputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bool",
                name: "settled",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "comment",
                type: "string",
            },
        ],
        name: "createBidWithComment",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "duration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsToken",
                name: "_nouns",
                type: "address",
            },
            {
                internalType: "address",
                name: "_weth",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minBidIncrementPercentage",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract INounsToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reservePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
        ],
        name: "setMinBidIncrementPercentage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
        ],
        name: "setReservePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
        ],
        name: "setTimeBuffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleCurrentAndCreateNewAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timeBuffer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsAuctionHouseV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsAuctionHouseV2__factory = NounsAuctionHouseV2__factory;
NounsAuctionHouseV2__factory.bytecode = _bytecode;
NounsAuctionHouseV2__factory.abi = _abi;
